module.exports = __webpack_public_path__ + "img/communication5.5f194782.png";